import { MOBILE_AGENTS } from './constants'

export const isMobileAgent = () => !!MOBILE_AGENTS.filter(uAgent => navigator.userAgent.match(uAgent)).length


export const createInputHidden = (inputHiddenName, inputValue) => {
  const inputHidden = document.createElement('input');
  
  let inputAttributes = {
    name: inputHiddenName,
    type: 'hidden',
    ...(inputValue && { value: inputValue })
  }

  Object.entries(inputAttributes).forEach(([attr, value]) => inputHidden.setAttribute(attr, value))
  return inputHidden
};

export const toggleMobileSideBar = () => {
  if (typeof(afdDevice) !== "undefined" && afdDevice != "desktop") {
    
    const sideBar = document.querySelector('.kth-sidebar')
    const mainContent = document.querySelector('.js-main-content')
    const showSideBar = document.querySelector('.js-show-sidebar');
    
    showSideBar && showSideBar.addEventListener('click', e => {
      e.preventDefault();
      sideBar.style.display = 'block'
      mainContent.classList.add('afd-hide')
    })
  }
}
